import React from "react";

export class ResponsibleDisclosurePTBR extends React.Component {
    render() {
        return (
            <>
                <p>
                    Data de revisão: <b>29/03/2024</b>
                    <br />
                    <br />
                </p>

                <p>A DH Healthcare GmbH considera importante que suas informações e sistemas sejam seguros.</p>

                <p>Apesar da nossa preocupação com a segurança desses sistemas, ainda pode existir uma vulnerabilidade.</p>

                <p>
                    Se você encontrou uma vulnerabilidade em um de nossos sistemas, informe-nos para que possamos tomar as medidas o mais rápido possível. Gostaríamos de trabalhar
                    com você para proteger nossos dados, nossos usuários e nossos sistemas de uma maneira melhor.
                </p>

                <p>
                    Por isso, optamos por uma política de divulgação coordenada de vulnerabilidades (também conhecida como “Política de Divulgação Responsável”) para que você possa
                    nos informar quando descobrir uma vulnerabilidade.
                </p>

                <p>Esta Política de Divulgação Responsável se aplica aos seguintes sistemas, mantidos pela DH Healthcare GmbH:</p>
                <ul>
                    <li>
                        <a href="https://www.dedalus.com/be/en/our-offer/products/pacsonweb/" target="_blank" rel="noreferrer">
                            www.dedalus.com
                        </a>
                    </li>
                    <li>
                        <a href="https://secure.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://secure.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://france.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://france.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://norway.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://norway.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://swiss.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://swiss.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://germany.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://germany.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://latem.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://latem.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://brazil.imaging.dedalus.com" target="_blank" rel="noreferrer">
                            https://brazil.imaging.dedalus.com
                        </a>
                    </li>
                    <li>
                        <a href="https://austria.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://austria.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://swisscom.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://swisscom.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://labs.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://labs.pacsonweb.com
                        </a>
                    </li>

                    <li>
                        <a href="https://secure.risonweb.com" target="_blank" rel="noreferrer">
                            https://secure.risonweb.com
                        </a>
                    </li>
                </ul>

                <p>
                    Em caso de dúvida, entre em contato conosco para esclarecer o assunto através do e-mails{" "}
                    <a href="mailto:security.disclosure@dedalus.com">security.disclosure@dedalus.com</a>
                </p>

                <h2>O que pedimos de você</h2>

                <p>Se você descobrir uma vulnerabilidade em um dos nossos sistemas, pedimos que:</p>

                <ul>
                    <li>
                        Denuncie a vulnerabilidade o mais rápido possível após a descoberta. Envie suas descobertas para{" "}
                        <a href="mailto:security.disclosure@dedalus.com">security.disclosure@dedalus.com</a>.
                    </li>
                    <li>
                        Forneça informações suficientes para reproduzir a vulnerabilidade para que possamos resolver o problema o mais rápido possível. Normalmente, a URL do
                        sistema afetado e uma descrição da vulnerabilidade são suficientes, mas para vulnerabilidades mais complexas pode ser necessário mais.
                    </li>
                    <li>
                        Deixe seus dados de contato, para que a DH Healthcare GmbH possa entrar em contato com você para chegarmos juntos a um resultado seguro. Deixe pelo menos o
                        seu nome, endereço de e-mail e/ou número de telefone. É possível denunciar sob um pseudônimo, mas certifique-se de que possamos entrar em contato com você
                        se tivermos dúvidas adicionais.
                    </li>
                    <li>Confirme que você agiu e continuará a agir de acordo com esta Política de Divulgação Responsável.</li>
                </ul>

                <h2>Regras que você deve seguir</h2>

                <ul>
                    <li>Não divulgue a vulnerabilidade até que possamos corrigi-la. Veja abaixo a possível publicação</li>
                    <li>
                        Não explore a vulnerabilidade copiando, excluindo, adaptando ou visualizando dados desnecessariamente. Ou, por exemplo, baixando mais dados do que o
                        necessário para demonstrar a vulnerabilidade.
                    </li>
                    <li>
                        Não realize as seguintes ações:
                        <ul>
                            <li>Colocar malware (vírus, worm, cavalo de Troia etc.).</li>
                            <li>Copiar, modificar ou excluir dados em um sistema.</li>
                            <li>Fazer alterações no sistema.</li>
                            <li>Acessar repetidamente o sistema ou compartilhar o acesso com outras pessoas.</li>
                            <li>Usar ferramentas de digitalização automatizadas.</li>
                            <li>Usar a chamada “força bruta” de acesso aos sistemas.</li>
                            <li>Usar ataques (D)DOS, ataques físicos ou engenharia social (phishing, vishing, spam,...).</li>
                        </ul>
                    </li>
                    <li>Apague imediatamente todos os dados obtidos por meio de vulnerabilidade assim que forem denunciados à DH Healthcare GmbH.</li>
                    <li>
                        Não realize ações que possam ter impacto no bom funcionamento do sistema, tanto em termos de disponibilidade e desempenho, mas também em termos de
                        confidencialidade e integridade dos dados.
                    </li>
                </ul>

                <p>
                    Os atos sob esta Política de Divulgação Responsável devem se limitar a realizar testes para identificar possíveis vulnerabilidades e compartilhar essas
                    informações com a DH Healthcare GmbH.
                </p>
                <p>
                    Se, após a remoção da vulnerabilidade, você desejar publicar informações sobre a vulnerabilidade, solicitamos que nos notifique pelo menos um mês antes da
                    publicação e nos dê a oportunidade de responder. A nossa identificação em uma publicação poderá ser feita somente após nossa aprovação explícita.
                </p>

                <h2>O que prometemos</h2>

                <p>Se você cumpriu os termos acima da Política de Divulgação Responsável e não cometeu nenhuma outra violação,</p>
                <ul>
                    <li>não tomaremos nenhuma ação legal contra você.</li>
                    <li>responderemos à sua denúncia em um curto período, se possível em até 10 dias úteis, com nossa análise da denúncia e qualquer data para resolução.</li>
                    <li>
                        trataremos sua denúncia de forma confidencial e não compartilharemos seus dados pessoais com terceiros sem o seu consentimento, a menos que isso seja
                        necessário para cumprir uma obrigação legal.
                    </li>
                    <li>o manteremos informado sobre o andamento da solução do problema.</li>
                    <li>
                        Queremos agradecer a você por denunciar um problema de segurança que ainda não é conhecido por nós, oferecendo a oportunidade de ser listado em nosso{" "}
                        <a href="/POW3/HallOfFame">"Hall Of Fame"</a>.
                    </li>
                    <li>nos esforçamos para resolver todos os problemas dentro de um curto período</li>
                </ul>

                <p>No entanto, podemos optar por ignorar denúncias de baixa qualidade.</p>
                <p>
                    Se você tiver alguma dúvida, nós o encorajamos a encaminhá-las para <a href="mailto:security.disclosure@dedalus.com">security.disclosure@dedalus.com</a>
                </p>
                <p>
                    Em caso de dúvida sobre a aplicabilidade desta política, entre em contato conosco primeiro através deste endereço de e-mail, para solicitar permissão explícita.
                </p>
                <p>Reservamo-nos o direito de alterar o conteúdo desta Política a qualquer momento ou rescindir a Política.</p>
                <p>
                    Este texto é um trabalho derivado de “Responsible Disclosure” (Divulgação responsável) de Floor Terra, usado sob uma licença Creative Commons Attribution 3.0.
                </p>
            </>
        );
    }
}
